import React from "react";
import moment from "moment";
import { connect } from "react-redux";

import { goTo } from "../../tools";
import { movil } from "../../app-movil";
import { nombreProductoGM, getNumPoliza } from "../../common/logica";
import { authentication, database, logOut, fbDbRefs } from "../../app-database";
import { savePhotoToBucketKmFinal, getClientInfo } from "./pagoPorKilometro.act"
import { String } from "es6-shim";

import Modal from "../../generalcomponets/modal-mobile/index";
import ModalFullScreen from '../../generalcomponets/modal-full-screen'
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import {Card} from "material-ui/Card";
import TextField from "material-ui/TextField";

const mapState = (state) => {
	return {
		"loading": state.global.loading,
		// "poliza": state.polizas.poliza,
		"ts": state.polizas.ts,
		"callTs": state.polizas.callTs,
		"timeout": state.polizas.inactividad,
		// "pagoPorKM": state.polizas.pagoPorKilometro,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		cerrarDetalle: () => {
			dispatch({ "type": "REINICIAR_CONTADOR_DETALLE_MOVIL" });
			dispatch({ "type": "IDENTIDAD_MOVIL_INVALIDA" });
			dispatch({ "type": "CERRAR_DETALLE_MOVIL" });
		},
		actualizaTouchId: () => {
			dispatch({ "type": "REINICIAR_CONTADOR_DETALLE_MOVIL" });  
		},
		descargarCertificado: (sPoliza, sCertificado) => {
			dispatch(descargarCertificadoAzul(sPoliza, sCertificado, true));
		},
		regresar: () => {
			dispatch({ "type": "IDENTIDAD_MOVIL_INVALIDA" });
			dispatch({ "type": "CERRAR_DETALLE_MOVIL" });
		},
		descargarDocumento: (sDocumento, sPoliza, sVersion, sRecibo, bMovil) => {
			dispatch(descargarDocumento(sDocumento, sPoliza, sVersion, sRecibo, bMovil));
		},
		mostrarErrorSesion: () => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Importante", "mensaje": "Has excedido el tiempo de visualización de la póliza. Para poder acceder a ella se te solicitará verificar tu identidad." });
		},
		savePhoto: (photo, nombreContratante, callback) => {
			dispatch(savePhotoToBucketKmFinal(photo, nombreContratante, callback));
		},
		reloadData: (poliza, version) => {
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};
const cameraPlaceholderVin = require("../../img/vin.png");
const cameraPlaceholderOdo = require("../../img/Corners.png");
const cameraPlaceholder1 = require("../../img/auto1.png");
const cameraPlaceholder2 = require("../../img/auto2.png");
const cameraPlaceholder3 = require("../../img/auto3.png");
const cameraPlaceholder4 = require("../../img/auto4.png");

const campoSettings = {
	fontFamily:"Roboto",
	fontStyle: "normal",
	fontWeight: "normal",
	mixBlendMode: "normal",
}

const floatingLabelStyleSettings={
		...campoSettings,
		lineHeight: "24px",
		letterSpacing: "0.5px",
		color: "#0C2040",
		zIndex: 0
}

const floatingLabelFocusStyleSettings={
	...campoSettings,
	lineHeight: "16px",
	letterSpacing: "0.4px",
	color: "#647085",
}

class PagoPorKMFinal extends React.Component {

	state = {
		"kmIni": "",
		"kmFin": "",
		"camara1Photo": cameraPlaceholderOdo,
		"needSubmit1": false,
		"supDer": cameraPlaceholder2,
		"supIzq": cameraPlaceholder1,
		"infDer": cameraPlaceholder3,
		"infIzq": cameraPlaceholder4,
		"vin": cameraPlaceholderVin,
		"supDerEnabled": true,
		"supIzqEnabled": true,
		"infDerEnabled": true,
		"infIzqEnabled": true,
		"vinEnabled": true,
		"supDerSubmit": false,
		"supIzqSubmit": false,
		"infDerSubmit": false,
		"infIzqSubmit": false,
		"vinSubmit": false,
		source: "",
		startCamera: true,
		endCamera: false,
		disableSendButton: true,
		enableTextBox: false,
		enableEndTextBox: false,
		startCameraEnabled: false,
		endCameraEnabled: false,
		disableFirstSection: false,
		disableSecondSection: true,
		vinFilled: false,
		filledStart: false,
		siCupon: true,
		nombreCompleto: "",
		modalConfirmacion: false,
		modalAutorizador: false,
		modalRegistroCupon: false,
		modalRegistroNoCupon: false,
		modalError: false,
		modalError2: false,
		modalSalir: false,
	}

	cargarImagen = (sImagen) => {
		var state = {};
		state[sImagen] = true;
		this.setState(state);
	}

	mostrarPantalla = () => {
		if ( !this.state.cargaCompleta ) {
			var _this = this;
			var ini = moment(this.props.appParams.fchVigenciaInicial, "DD/MM/YYYY").valueOf();
			var fin = moment(this.props.appParams.fchVigenciaFinal, "DD/MM/YYYY").valueOf();
			var now = moment().valueOf();

			var color = "#183D7B", vigencia = "90%";

			if (now > fin) {
				color = "#FF6F20";
				vigencia = "100%";
			}

			if (now < fin) {
				vigencia = (((now - ini) * 100) / (fin - ini)) + "%";
			}

			setTimeout(() => {
				$(".contenedor-detalle").addClass("contenedor-detalle-visible");
			}, 300);
			setTimeout(() => {
				$(".detalle-poliza").addClass("detalle-poliza-visible");
			}, 500);
			setTimeout(() => {
				$(".titulo-detalle").addClass("titulo-detalle-visible");
			}, 700);
			setTimeout(() => {
				$(".botones-detalle").addClass("botones-detalle-visible");
			}, 900);
			setTimeout(() => {
				_this.setState({ "vigencia": vigencia, "colorVigencia": color, "cargaCompleta": true });
				_this.props.actualizaTouchId();
			}, 1200);
		}
	}

	validaInactividad = () => {
		if (new Date() > new Date(this.props.callTs + this.props.timeout)) {
			this.props.mostrarErrorSesion();
			this.props.regresar();
			let mensaje = {"return": "home"};
			movil("", mensaje);
			// goTo("movil/polizas");
			//window.location.href = "/#!/movil/polizas";
			return false;
		} else {
			this.props.actualizaTouchId();
			return true;
		}
	}

	obtenerFechaLimiteInicio = () => {

		moment().locale('es');
		var date = moment(this.props.appParams.fchVigenciaInicial, 'DD/MM/YYYY').add(14, 'days').format('L');
		// .add(15, 'days').format('L')

		return date;

	}

	obtenerFechaLimiteTermino = () => {

		moment().locale('es');
		var date = moment(this.props.appParams.fchVigenciaFinal, 'DD/MM/YYYY').subtract(30, 'days').format('L');

		return date;

	}

	openSalir = () => {
		this.setState({ modalSalir: true });
	}

	regresar = () =>{
		this.setState({ modalSalir: false });
		this.props.regresar();
		let mensaje = {"return": "home"};
		movil("", mensaje);
		// goTo("movil/detalle");
	}

	getDeviceType(){

		if(typeof window.webkit != "undefined" && window.webkit.messageHandlers) return "iOS";
		if(typeof android_conectam != "undefined") return "android";
		return "browser";

	}

	activateCameraByDeviceType(payload){

		switch(this.getDeviceType()){
			case "iOS":
				window.webkit.messageHandlers.callbackHandler.postMessage(payload);
			break;

			case "android":
				android_conectam.callbackHandler(JSON.stringify(payload.error), JSON.stringify(payload.data));
			break;
		}
	}

	takePhoto(source, enabled){
		if(!enabled) return;

		var payload = {
			"data": {
				"proceso": "camara",
				"return": "savePhoto()"
			},
			"error": "errorHandler"
		};
		
		this.setState({
			source: source
		});

		this.activateCameraByDeviceType(payload);



	}

	savePhoto(){

		// let poliza = this.props.pagoPorKM[this.props.appParams.numPoliza];

		switch(this.state.source){
			case "fin":
				this.setState({
					camara1Photo: 'data:image/png;base64,' + window.photo,
					enableTextBox: !this.props.appParams.isEndKmCaptured,
					needSubmit1: true,
					filledStart: true,					
				},()=>{
					if(this.state.infDerFilled && 
						this.state.infIzqFilled && 
						this.state.supDerFilled && 
						this.state.supIzqFilled &&
						this.state.vinFilled &&
						this.state.kmFin){
						this.setState({disableSendButton:false});
					}
				});

			break;

			default:
				const newState= {}
				newState[this.state.source] = "data:image/png;base64," + window.photo;
				newState[this.state.source+"Enabled"] = true;
				newState[this.state.source+"Submit"] = true;
				newState[this.state.source+"Filled"] = true;								

				this.setState(newState,()=>{
					if(this.state.infDerFilled && 
						this.state.infIzqFilled && 
						this.state.supDerFilled && 
						this.state.supIzqFilled &&
						this.state.vinFilled &&
						this.state.kmFin){
						this.setState({disableSendButton:false});
					}
				});

		}
		

	}

	componentDidMount(){

		// let poliza = this.props.pagoPorKM[this.props.poliza.generales.numPoliza];
		if(this.props.appParams !== null && typeof this.props.appParams !== "undefined"){
			if(this.props.appParams.isEndKmCaptured){
				this.setState({
					camara1Photo: this.props.appParams.endPhoto,
					kmFin: String(this.props.appParams.endKm).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
					startCameraEnabled: false,
					enableTextBox: false,
					filledStart: true,					
					disableFirstSection: this.props.appParams.isEndKmCaptured,
					nombreCompleto : `${this.props.appParams.nombres} ${this.props.appParams.apellidoPaterno} ${this.props.appParams.apellidoMaterno}`
				})
			}else{

				this.setState({
					nombreCompleto : `${this.props.appParams.nombres} ${this.props.appParams.apellidoPaterno} ${this.props.appParams.apellidoMaterno}`,
					startCameraEnabled: true,
					enableTextBox: true,
					filledStart: false
				});

			}

			this.setStateCameraPhoto(this.props.appParams, "supIzq");
			this.setStateCameraPhoto(this.props.appParams, "supDer");
			this.setStateCameraPhoto(this.props.appParams, "infIzq");
			this.setStateCameraPhoto(this.props.appParams, "infDer");
			this.setStateCameraPhoto(this.props.appParams, "vin");
		}
	}

	setStateCameraPhoto(poliza, key){
		const newState = {};
		if (poliza[key]){			
			newState[key] = poliza[key];
			newState[key+"Enabled"] = false;			
			newState[key+"Filled"] = true;			
		}else{
			newState[key+"Enabled"] = this.props.appParams.enabled;			
		}		
		this.setState(newState);	
	}

	SendPhoto(){
		this.setState({ modalConfirmacion: false });
		//$("#modal-confirmacion").modal("hide");

		// let poliza = this.props.pagoPorKM[this.props.poliza.generales.numPoliza];

		this.setState({
			enableTextBox: false
		});
		let photo = {
			poliza: "",
			version: "",
			km: "",
			type: "",
			photo: ""
		};
		if(this.state.needSubmit1){
				photo.poliza = this.props.appParams.numPoliza,
				photo.version = this.props.appParams.numVersion,
				photo.km = this.state.kmFin.replace(',', ''),
				photo.type = "fin",
				photo.photo = this.state.camara1Photo
			}
		if(!this.state.filledStart){
			return;
		}
		if( this.state.camara1Photo !== cameraPlaceholderOdo
			&& this.state.kmFin !== ""){		
			this.setState({disableSendButton:true},()=>{
				this.props.savePhoto(photo, this.state.nombreCompleto, (result) => {
					if(!result.res) {
						this.setState({
							startCameraEnabled: true,
							enableTextBox: true,
							disableSendButton: false
						});
					}
					if(result.modal) {
						switch(result.modal) {
							case 'modalAutorizador':
								this.setState({modalAutorizador: true, modalError: false})
								break;
							case 'modalRegistroCupon':
								this.setState({modalRegistroCupon: true})
								break;
							case 'modalRegistroNoCupon':
								this.setState({modalRegistroNoCupon: true})
								break;
							case 'modalError':
								this.setState({modalError: true})
								break;
							case 'modalError2':
								this.setState({modalError2: true})
								break;
							default:
								this.setState({modalError: true})
								break;
						}
					}
				});
			});
		}
	}
	
	validarEnviar(key,photos){
		if(this.state[key+"Submit"]){
			photos.push({
				poliza:this.props.appParams.numPoliza, 
				version: this.props.appParams.numVersion, 
				km: 0, 
				type: key, 
				photo: this.state[key]
			});
		}
		return this.state[key +"Filled"];
	}

	kmFin(e){
		if(e.target.value.length <= 7){
			if( this.state.camara1Photo !== cameraPlaceholderOdo && this.state.kmfin !== "" ){
				this.setState({disableSendButton:false});
			}
			this.setState({
				kmFin: e.target.value.replace(",", "").replace(/[^\d,]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","),
			});
		}
	}

	ShowConfirmationModal() {
		this.setState({ modalConfirmacion: true });
	}

	aceptar = ( modal ) => {
		let redux = angular.element(document.querySelector("ui-view")).scope().$parent.state.redux;
		if(modal==="modal-registro-cupon"){
			this.props.tagManager({
				dispositivo: this.props.dispositivo,
				type: "EVENT_CLICK_REGISTRO_GANADOR"
			});
			this.setState({ modalRegistroCupon: false });
		} else {
			this.props.tagManager({
				dispositivo: this.props.dispositivo,
				type: "EVENT_CLICK_REGISTRO_NO-GANADOR"
			});
			this.setState({ modalRegistroNoCupon: false });
		}
		redux.dispatch({
			type: "LOADER_SHOW" 
		});
		getClientInfo(this.props.appParams.numPoliza,this.props.appParams.numVersion).then(
			response => {
			let pagoPorKilometro = this.props.appParams;
			pagoPorKilometro[this.props.appParams.numPoliza] = response;
			redux.dispatch({
				type: "SET_PXK",
				pagoPorKilometro: pagoPorKilometro
			});
			redux.dispatch( { type: "LOADER_HIDE"});

			// goTo("/movil/detalle/consultaKMFinal");
		});
		let mensaje = {"return": "home"};
		movil("", mensaje);		
		// window.location.reload(true);
	}

	aceptarError() {
		this.setState({ modalError: false });
	}
	aceptarError2() {
		this.setState({ modalError2: false });
	}
	aceptarAutorizador(){
		this.props.tagManager({
			dispositivo: this.props.dispositivo,
			type: "EVENT_CLICK_REGISTRO_VALIDACION-KM-FINAL"
		});
		this.setState({ modalAutorizador: false });
		let mensaje = {"return": "home"};
		movil("", mensaje);
		// goTo("movil/polizas");
		// window.location.reload(true);
	}

	volver(){
		this.setState({ modalConfirmacion: false });
		//$("#modal-confirmacion").modal("hide");

	}

	closeSalir = () => {
		this.setState({ modalSalir: false });
	}

	render() {
		// let ramo = this.props.poliza.generales.cveRamo;
		let telPagar, telConsultar, telSiniestros;
		// if (this.state.poliza && this.state.vigencia && this.state.servicios && this.state.descargas && !this.state.cargaCompleta) {
			this.mostrarPantalla();
		// }
		// let poliza = this.props.pagoPorKM[this.props.poliza.generales.numPoliza];
		return(
			<MuiThemeProvider>
				<div className="polizas-mobile">
					{this.state.modalConfirmacion &&
						<Modal closeModalFromChild={() => null}>
							<span className="title-mail" style={{"margin-top": "32px"}}>Enviar datos</span>
								<div className="row">
									<div className="col-xs-12 mb-20">
										<div className="text-center">
											<span className="gnp-material-content-modal">
												{`¿Deseas enviar los datos registrados? Una vez que se envien, no se podrán modificar.`}
											</span>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-xs-12">
										<div className="text-center aceptar-cancelar-btn">
											<a onClick={this.SendPhoto.bind(this)} className="orange-movil">Continuar</a>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-xs-12">
										<div className="text-center aceptar-cancelar-btn">
											<a onClick={this.volver.bind(this)} className="btn-modal">Cancelar</a>
										</div>
									</div>
								</div>
						</Modal>
					}
					{this.state.modalAutorizador &&
						<ModalFullScreen closeModalFromChild={() => null}>
							<img src={require('../../img/dbk-nwb-validacion.png')} style={{width: '100%'}}/>
							<div className="container">
								<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top no-padding-modal">
										<label className="gnp-material-title-modal">Registro en validación</label>
									</div>
									<div className="col-md-12 col-sm-12 col-xs-12 margin-modal no-padding-modal">
										<p className=" gnp-material-content-modal">Tu información ha sido enviada y será validada. Te invitamos a comunicarte 
												a <strong>Línea GNP 55 5227 9000</strong> opción Beneficios Soy Cliente GNP para agilizar tu registro.</p>
									</div>
									<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom no-padding-modal">
										<button type="button" onClick={this.aceptarAutorizador.bind(this)} className="pure-material-button-contained btn-full-width">Aceptar</button>
									</div>
								</div>
							</div>
						</ModalFullScreen>
					}
					{this.state.modalRegistroCupon &&
						<ModalFullScreen id="modal-registro-cupon" closeModalFromChild={() => this.aceptar("modal-registro-cupon")}>
							<div className="text-center">
								<img style={{width: "292px", height: "208px"}} src={require("../../img/registro-exitoso.png")} />
							</div>
							<span className="title-mail" style={{"margin-top": "32px"}}>Registro de información exitoso</span>
							<div className="row">
								<div className="col-xs-12 mb-20">
									<div className="text-policy">
										<span >
											<span>Felicidades por ser un Conductor Ecológico GNP por bajo kilometraje.</span>
											<br/><br/>
											<span style={{fontSize: "16px"}}> 
												Recorriste menos de 7,000 km durante tu vigencia y obtuviste una bonificación de tu Seguro GNP.
											</span>
										</span>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-xs-12 mt-40">
									<div className="text-center aceptar-cancelar-btn">
										<a onClick={() => this.aceptar("modal-registro-cupon")} className="orange-movil">Aceptar</a>
									</div>
								</div>
							</div>
						</ModalFullScreen>
					}
					{this.state.modalRegistroNoCupon &&
						<ModalFullScreen id="modal-registro-noCupon" closeModalFromChild={() => this.aceptar("modal-registro-noCupon")}>
							<div className="text-center">
								<img style={{width: "292px", height: "208px"}} src={require("../../img/informacion-exitoso2.png")} />
							</div>
							<span className="title-mail" style={{"margin-top": "32px"}}>Registro de información exitoso</span>
							<div className="row">
								<div className="col-xs-12 mb-20">
									<div className="text-policy">
										<span style={{fontSize: "16px"}}>
											Recibimos tu información capturada. En esta ocasión recorriste más de los 7,000 km 
											que reconoce el beneficio de Distintivo bajo kilometraje GNP.
										</span>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-xs-12 mt-40">
									<div className="text-center aceptar-cancelar-btn">
										<a onClick={() => this.aceptar("modal-registro-noCupon")} className="orange-movil">Aceptar</a>
									</div>
								</div>
							</div>
						</ModalFullScreen>
					}
					{this.state.modalError &&
						<Modal closeModalFromChild={() => null}>
							<div className="text-center mt-20">
								<i><img src={require('../../img/warning-new-style.svg')} /></i>
							</div>
							<span className="title-mail" style={{"margin-top": "16px"}}>Error al realizar el registro</span>
							<div className="row">
								<div className="col-xs-12 mb-20 mt-20">
									<div className="text-policy">
										<span style={{fontSize: "16px"}}>
											El kilometraje que ingresaste manualmente no coincide con tu fotografía. Revisa el kilometraje de tu vehículo y captura los datos nuevamente.
										</span>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-xs-12 mt-40">
									<div className="text-center aceptar-cancelar-btn">
										<a onClick={this.aceptarError.bind(this)} className="orange-movil">Aceptar</a>
									</div>
								</div>
							</div>
						</Modal>
					}
					{this.state.modalError2 &&
						<Modal closeModalFromChild={() => null}>
							<div className="text-center mt-20">
								<i><img src={require('../../img/warning-new-style.svg')} /></i>
							</div>
							<span className="title-mail" style={{"margin-top": "16px"}}>Error al realizar el registro</span>
							<div className="row">
								<div className="col-xs-12 mb-20 mt-20">
									<div className="text-policy">
										<span style={{fontSize: "16px"}}>
											Servicio no disponible, por favor intente más tarde
										</span>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-xs-12 mt-40">
									<div className="text-center aceptar-cancelar-btn">
										<a onClick={this.aceptarError2.bind(this)} className="orange-movil">Aceptar</a>
									</div>
								</div>
							</div>
						</Modal>
					}
					{this.state.modalSalir &&
						<Modal closeModalFromChild={() => null}>
							<div className="text-center mt-20">
								<i><img src={require('../../img/warning-new-style.svg')} /></i>
							</div>
							<span className="title-mail" style={{"margin-top": "16px"}}>Salir del registro</span>
							<div className="row">
								<div className="col-xs-12 mb-20 mt-20">
									<div className="text-policy">
										<span style={{fontSize: "16px"}}>
											¿Estás seguro que deseas salir del trámite?<br/>
											Se perderán los datos introducidos.
										</span>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-xs-12 mt-30">
									<div className="text-center aceptar-cancelar-btn">
										<a onClick={this.closeSalir.bind(this)} className="orange-movil">Continuar</a>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-xs-12">
									<div className="text-center aceptar-cancelar-btn">
										<a onClick={this.regresar} className="btn-modal">Salir</a>
									</div>
								</div>
							</div>
						</Modal>
					}
					<div className="container">
						<div className="box-wrap">
							<div className="cards-wrap mt-25 contenedor-detalle">
								<div className="row">
									<div className="" style={{"margin": "5% auto 0 auto", "width": "90%", "position": "relative", "borderRadius": "0px 0px 10px 10px"}} aria-hidden="false">
										<div className="clearfix no-poliza-movil">
											<div className="pull-left">
												<span className="title-policy">No. Póliza: {this.props.appParams.numPoliza}</span>
											</div>
											<div className="pull-right">
												<p className="no-margin"><b className="orange-text"></b></p>
											</div>
										</div>
										<div className="row" style={{"paddingTop": "5%", "marginBottom": "20px"}}>
											<div className="col-xs-3">
												<img className="center-block" src={require("../../img/smart-trip.png")} style={{"width": "48px", "height": "48px"}} />
											</div>
											<div className="col-xs-9">
												<p>
													<span className="subtitle-policy">Distintivo bajo kilometraje</span>
													{this.props.appParams.terminoPoliza &&
														<p className="text-policy">Fecha límite de registro:<br/>{this.props.appParams.terminoPoliza}</p>
													}
												</p>
											</div>
										</div>
										<button style={{position:"absolute", display:'none'}} id="cameraEvent" onClick={this.savePhoto.bind(this)}/>
											<div className="row">
												<div className="col-xs-3"></div>
												<div className="col-xs-6 image-cards-registro-km-fin">
													{!this.state.filledStart ?
														<Card
															style={{
																borderRadius: "4px",
																padding: "8px 8px 8px 8px",
																zIndex: "0 !important"
															}}
															onClick={this.takePhoto.bind(this, "fin", this.state.startCameraEnabled)}
														>
															<div className="add-photo-container">
																<img
																	src={cameraPlaceholderOdo}
																	className="odo-image-card-km-fin"
																/>
																<div className="add-photo-centered">
																	<img src={require("../../img/add-photo-new.svg")} />
																</div>
																<div className="add-photo-text-centered">Kilometraje actual</div>
															</div>
														</Card>
													:
														<Card
															className="height-card-filled"
															onClick={this.takePhoto.bind(this, "fin", this.state.startCameraEnabled)}
														>
															<div>
																<img
																	className="image-filled"
																	src={this.state.camara1Photo}
																/>
																<div className="text-card-filled">
																	Kilometraje actual
																</div>
															</div>
														</Card>
													}
												</div>
												<div className="col-xs-2"></div>
											</div>
											<div className="row">
												<div className="col-xs-12">
													<TextField
														disabled={(!this.state.enableTextBox) ? true : false}
														floatingLabelText={!this.state.startCameraEnabled ? "Kilometraje final" :"Ingresa tu kilometraje:"}
														fullWidth={true}
														underlineStyle={{borderColor: "#AAC3EE"}}
														underlineFocusStyle={{borderColor: "#AAC3EE"}}
														floatingLabelStyle={floatingLabelStyleSettings}
														floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
														value={this.state.kmFin}
														onChange={this.kmFin.bind(this)}
														type="tel"
														pattern="[0-9]*"
														noValidate
														id="camera-start"
													/>
												</div>
											</div>
										<div className="row">
											<div className="col-xs-12 elements-width" style={{"marginTop": "40%"}}>
												<button disabled={this.state.disableSendButton} onClick={this.ShowConfirmationModal.bind(this)} id="send-button" type="button" className="pure-material-button-contained btn-full-width">Continuar</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</MuiThemeProvider>
		);
	}
}

export default connect(mapState, mapDispatch)(PagoPorKMFinal);


// WEBPACK FOOTER //
// ./src/movil/polizas/pagoPorKMFinal.cmpt.js